"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueParamsName = exports.styles = exports.smallScrollbar = exports.packageKey = exports.maxFlushTime = exports.flushProcess = exports.deviceGroupNameTrinkwasser = exports.deviceGroupNameHeizung = exports.defaultFlushTime = exports.contentType = exports.commandsTypes = exports.commandsByType = exports.colors = exports.circles = exports.circleType = void 0;
var _paulCorePackage = require("paul-core-package");
const {
  ComponentTypes
} = _paulCorePackage.constants;
const packageKey = exports.packageKey = 'paul_cards_package';
const maxFlushTime = exports.maxFlushTime = 300;
const defaultFlushTime = exports.defaultFlushTime = 60;
const deviceGroupNameTrinkwasser = exports.deviceGroupNameTrinkwasser = [ComponentTypes.PwhC, ComponentTypes.PwhPipe, ComponentTypes.PwcPoe, ComponentTypes.PwhSupply];
const deviceGroupNameHeizung = exports.deviceGroupNameHeizung = [ComponentTypes.HtgCc, ComponentTypes.HtgSys, ComponentTypes.HtgSub, ComponentTypes.HtgHx, ComponentTypes.HtgPipe];
const circleType = exports.circleType = {
  temperature: 'temperature',
  power: 'power',
  flow: 'flow'
};
const circles = exports.circles = {
  first: 'first',
  second: 'second'
};
const flushProcess = exports.flushProcess = {
  flush: 'flush',
  open: 'open',
  close: 'close'
};
const commandsTypes = exports.commandsTypes = {
  FLEX_DURATION: 'FLEX_DURATION'
};
const commandsByType = exports.commandsByType = {
  [commandsTypes.FLEX_DURATION]: '/flushDuration'
};
const contentType = exports.contentType = {
  layoutGrid: "layout-grid",
  table: "table"
};

/**
 @todo: colors object should be deleted after installing MUI Theme and refactoring components to use theme colors
 **/
const colors = exports.colors = {
  'main-color-cl-01': '#00205B',
  'main-color-cl-01-hover': '#002B7A',
  'main-color-cl-02': '#2D78C6',
  'main-color-cl-03': '#37AFEB',
  'main-color-cl-04': '#81D1F7',
  'main-color-cl-05': '#BBE9FF',
  'main-color-cl-06': '#E3F7FF',
  'main-color-cl-07': '#F6F8FC',
  'main-color-cl-08': '#FFFFFF',
  'main-color-cl-09': '#F3F3F3',
  'main-color-cl-10': '#212134',
  'main-color-cl-11': '#32324D',
  'main-color-cl-12': '#4A4A6A',
  'main-color-cl-13': '#666687',
  'main-color-cl-14': '#8E8EA9',
  'main-color-cl-15': '#A5A5BA',
  'main-color-cl-16': '#C0C0CF',
  'main-color-cl-17': '#DCDCE4',
  'main-color-cl-18': '#EAEAEF',
  'main-color-cl-19': '#F6F6F9',
  'main-color-cl-20': '#00BC4B',
  'main-color-cl-21': '#D02B20',
  'main-color-cl-22': '#F29D41',
  'main-color-cl-30': '#0000FF',
  'main-color-cl-31': '#1CE783',
  'main-color-cl-32': '#EFEFED',
  'main-color-cl-40': '#E5E5E7',
  'main-color-cl-90': 'rgba(#FF00FF, 0.3)',
  'main-color-cl-91': '#FF00FF',
  'main-color-cl-92': '#FCFCFD',
  'main-color-cl-93': '#FF8000',
  'main-color-cl-94': '#E71D1C',
  'main-color-cl-95': '#101828',
  'main-color-cl-96': '#000033',
  'main-color-cl-97': '#000066',
  'main-color-cl-98': '#475467',
  'main-color-cl-99': '#667085',
  'main-color-cl-100': '#98a2b3'
};

/**
 @todo: styles object should be deleted after installing MUI Theme and refactoring components to use theme colors
 **/
const styles = exports.styles = {
  transitionType: {
    primary: '.5s ease',
    secondary: '.2s ease'
  },
  boxShadow: {
    primary: '0 5px 15px rgb(0 0 0 / 10%)',
    secondary: '0 4px 10px rgba(0, 0, 0, 0.08)'
  },
  borderRadius: {
    button: '8px',
    input: '8px',
    card: '10px'
  },
  textCrop: function textCrop() {
    let lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return {
      overflow: "hidden",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: lines
    };
  }
};

/**
 @todo: styles object should be deleted after installing MUI Theme
 **/
const smallScrollbar = exports.smallScrollbar = {
  '&::-webkit-scrollbar': {
    width: '32px'
  },
  '&::-webkit-scrollbar-thumb': {
    borderWidth: '14px',
    borderTopWidth: 0
  }
};

/**
 @todo: move to core valueParamsName
 **/
const valueParamsName = exports.valueParamsName = {
  value: "value",
  valueType: "valueType",
  temperatureStatus: "temperatureStatus"
};